// Module
var code = "\n<label class=\"btn btn-default btn-file\">\n        {{'stock.readfile' | translate}} <input class=\"\" id=\"xlf\" type=\"file\" ng-model=\"file\" style=\"display: none;\">      \n</label>        \n</div>";
// Exports
module.exports = code;